import React, { useEffect, useState } from "react";
import ViewPreDefinedIndex from "../../../../components/View/ViewPreDefinedIndex";
import { useStandard } from "../../../../context/StandardContext";
import useGetStandardDetail from "../../../../hooks/useGetStandardDetail";
import { useLocation, useParams } from "react-router-dom";
import useFetchPreReport from "../../../../hooks/useFetchPreReport";
import NuDateFormat from "../../../../utils/NuDate";
import { CloseIcon, PaperClip } from "../../../../assets/icons";
import { useFormik } from "formik";
import { handleKeyDown } from "../../../../utils/OtherFunctions";
import { NuDate } from "../../../../utils/Inputs";
import FormikSelectTwo from "../../../../utils/Select";
import { CancelButton, SubmitButton } from "../../../../utils/Button";
import useGetStatusData from "../../../../hooks/useGetStatusData";
import DecryptData from "../../../../utils/Decrypt";
import useGetCompanyInfo from "../../../../hooks/useGetCompanyInfo";
import PDFGenerationScreen from "../../PDFGenerationScreen";

function AuditScheduleReport() {
  const { standardName } = useStandard();
  const { stdId } = useParams();
  let location = useLocation();

  const [value, setValue] = useState({
    standard_id: stdId,
    module_id: 6,
    type: location.state?.reportValue?.reset_count || 0,
    status_name: "",
    from_date:"",
    to_date:"",
  });

  const [params, setParams] = useState({
    standard_id: stdId,
    module_id: 6,
    type: location.state?.reportValue?.reset_count || 0,
    status_name: "",
    from_date: "",
    to_date:"",
    completion_start_date: "",
    completion_end_date: "",
    reminder_start_date: "",
    reminder_end_date: "",
  });

  const { statusValue } = useGetStatusData({ value: 12 });
  const [filter, setFilter] = useState(false);
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const { data, isLoading, review, getAllData,status } = useFetchPreReport({
    url: `/report/`,
    value: filter==true?params:value,
    hasFilter: filter,
  });
  const [showFiter, setShowFilter] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: params,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      console.log();
      setParams(value);
      setFilter(true)
      setTimeout(() => {
        setShowFilter(false);
      }, 600);
    },
  });

  function handleOnClose() {
    setShowFilter(false);
    formik.resetForm();
    setParams(value)
    setFilter(false)
  }

  const [pdfUrl, setPdfUrl] = useState(null);
  const userData = localStorage.getItem("aTaDrEsU")?DecryptData("aTaDrEsU"):[];
  const {company}=useGetCompanyInfo()
  const [isDataLoading,setIsDataLoading]=useState(true)
  useEffect(() => {
    const worker = new Worker(new URL('./asPDFWorker.jsx', import.meta.url));
    
    if(data.length>0){
      worker.onmessage = (e) => {
        setPdfUrl(e.data);
        setIsDataLoading(false);
      };
    }

    if (data.length > 0) {
      worker.postMessage({
        data,
        company:company,
        standardDetailName,
        review,
        standardStartDate,
        standardEndDate,
        Name: `Audit Schedule Report`,
        UserName: userData?.user_name,
        Location: userData?.location || "-",
        Country: userData?.country || "-",
        department: userData?.department || "-",
        header,
        status
      });
    }

   return () => {
      setIsDataLoading(false);
      worker.terminate();
    }
  }, [data,company,standardDetailName]);

  return (
    <>
      <ViewPreDefinedIndex
        label="Audit Schedule"
        standardName={standardName}
        menu="Report"
        header={header}
        isLoading={isLoading}
        review={review}
        hasFilter={filter}
        removeFilter={handleOnClose}
        dataView={data}
        startDate={standardStartDate}
        endDate={standardEndDate}
        setShowFilter={() => setShowFilter(true)}
        pdfUrl={pdfUrl}
        downloadFileName={`${standardName}-Audit Schedule Report ${
          standardStartDate &&
          NuDateFormat({
            value: standardStartDate,
            format: "MMM-YYYY",
          })
        } ${
          (standardEndDate ||
            standardEndDate) &&
          "to"
        } ${
          (standardEndDate ||
            standardEndDate) &&
          NuDateFormat({
            value:
            standardEndDate ||
            standardEndDate,
            format: "MMM-YYYY",
          })
        }.pdf`}

      />
      {showFiter && (
        <>
          <div
            id="modal"
            className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
    flex justify-center items-center "
          >
            <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
              <div className="flex items-start justify-between px-5 py-2  rounded-t">
                <h3 className="text-base 2xl:text-lg font-semibold">Filter</h3>
                <span
                  className="h-6 w-6 text-2xl block cursor-pointer"
                  onClick={handleOnClose}
                >
                  <CloseIcon />
                </span>
              </div>
              <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                <div className=" w-full  max-h-[70vh] overflow-y-auto relative px-6 flex flex-wrap justify-between">
                  <FormikSelectTwo
                    formik={formik}
                    name="status_name"
                    label="Status"
                    width="w-full"
                    placeholder="Select Status"
                    Options={statusValue}
                    zindex={12}
                  />
                </div>
                <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                  <CancelButton onClose={handleOnClose} />
                  <SubmitButton />
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    <PDFGenerationScreen visible={isDataLoading} activity={"Audit Schedule Report"} format={"pdf"} name={standardName}/>
    </>
  );
}

export default AuditScheduleReport;

const header = [
  {
    label: "Sl.No",
    width: "w-[5%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "serial_number",
    headone: "Sl No.",
    type: "text",
    pdfWidth: "5%",
    textAlign: "center",
  },
  {
    label: "Ref Number",
    width: "w-[5%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "reference_number",
    type: "text",
    headone: "Ref Number",
    pdfWidth: "5%",
    textAlign: "center",
  },
  {
    label: "Performed By",
    width: "w-[9%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "performed_by",
    type: "text",
    headone: "Performed By",
    pdfWidth: "9%",
    textAlign: "center",
  },
  {
    label: "Process Description",
    width: "w-[13%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "process_description",
    type: "text",
    headone: "Process Description",
    pdfWidth: "13%",
    textAlign: "center",
  },
  {
    label: "Audit Description",
    width: "w-[9%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "audit_description",
    type: "text",
    headone: "Audit Description",
    pdfWidth: "9%",
    textAlign: "center",
  },
  {
    label: "Auditee",
    width: "w-[9%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "auditee",
    type: "text",
    headone: "Auditee",
    pdfWidth: "9%",
    textAlign: "center",
  },
  {
    label: "Start Date",
    width: "w-[9%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "start_date",
    type: "date",
    headone: "Start Date",
    pdfWidth: "9%",
    textAlign: "center",
  },
  {
    label: "End Date",
    width: "w-[9%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "end_date",
    type: "date",
    headone: "End Date",
    pdfWidth: "9%",
    textAlign: "center",
  },
  {
    label: "Status",
    width: "w-[9%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "status",
    type: "text",
    headone: "Status",
    pdfWidth: "9%",
    textAlign: "center",
  },
  {
    label: "Results",
    width: "w-[9%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "result",
    type: "text",
    headone: "Results",
    pdfWidth: "9%",
    textAlign: "center",
  },
  {
    label: "Last Updated by",
    width: "w-[9%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "last_modified_name",
    feildnametwo: "created_by_name",
    type: "text",
    headone: "Last Updated by",
    pdfWidth: "9%",
    textAlign: "center",
  },
  {
    label: "Artefact",
    width: "w-[5%]",
    headerAlign: "center",
    rowAlign: "text-center",
    fieldname: "attachment",
    type: "file",
    headone: "Artefact",
    pdfWidth: "5%",
    textAlign: "center",
  },
];